<template>
  <Dialog v-model="show" title="Alert" :forceOption="forceOption" nocancel>
    <p v-if="!isArray(msg)" v-html="msg"></p>
    <ul v-else>
      <li v-for="m in msg" :key="m">
        {{ m }}
      </li>
    </ul>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from './Dialog.vue';
import { showAlertDialog, dialogMessage, forceOption } from '../utils';

const show = showAlertDialog;
const msg = dialogMessage;
const isArray = Array.isArray;
</script>
